
import React, { useState } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import ErrorWindow from './../ErrorWindow/ErrorWindow.js';
import { GetProducent } from './../../dao/DAO.js';
import './Login.css';


export default function Login({ setToken }) {
    const [username, setUserName] = useState();
    const [password, setPassword] = useState();
    //    function someParentFunction() {
    //        // The child component can call this function.
    //        return errorInfo;
    //    }
    var biRef = {
        // someParentFunction: someParentFunction
    }
    const handleSubmit = async e => {
        console.log("username:" + username);
        e.preventDefault();
        const data = await loginUser({
            operacja: "login",
            username,
            password
        });
        console.log("token" + data.token + " err:" + data.error);
        if (typeof (data.error) != 'undefined') {
            console.log("show error" + data.error.info);
            biRef.pokazOkno(data.error.info);
            setToken(null);
            return;
        }
        console.log("data.token1" + data.token);
        console.log("data.nip1" + data.nip);
        let datapr = await GetProducent(data.nip);
        console.log("producent login" + JSON.stringify(datapr));
        if ("error" in datapr) {
            console.log("error in" + datapr.error);
            setToken(null);
            biRef.pokazOkno(datapr.error.info);
            return;
        }
        sessionStorage.setItem('producent', JSON.stringify(datapr.producent));
        setToken(data);
        window.location =process.env.PUBLIC_URL+ "/start";
    }
    return (
        <Container className="p-4">
            <Row className="justify-content-md-center">
                <Col xs lg="1">&nbsp;</Col>
            </Row>
            <Row className="justify-content-md-center">
                <Col xs lg="4">
                    <Form className="logowanie-formularz" onSubmit={handleSubmit}>
                        <Form.Group controlId="formBasicEmail">
                            <Form.Label>E-mail adres</Form.Label>
                            <Form.Control className="logowanie" type="email" onChange={e => setUserName(e.target.value)} placeholder="Podaj adres" />
                        </Form.Group>
                        <Form.Group controlId="formBasicPassword">
                            <Form.Label>Hasło</Form.Label>
                            <Form.Control className="logowanie" type="password" onChange={e => setPassword(e.target.value)} placeholder="Hasło" />
                        </Form.Group>
                        <Button variant="primary" type="submit" className="float-right">
                            Zaloguj
                        </Button>
                        <ErrorWindow biRef={biRef} />
                    </Form>
                </Col>
            </Row>
        </Container>
    );
}

Login.propTypes = {
    setToken: PropTypes.func.isRequired
}
// withCredentials: true,
//   mode: 'no-cors',
async function loginUser(credentials) {
    console.log(process.env.REACT_APP_PS_AMARKA_SITE + JSON.stringify(credentials));
    return axios(process.env.REACT_APP_PS_AMARKA_SITE + '/api/' + process.env.REACT_APP_PS_AMARKA_API_VER + '/login', {
        method: 'POST',
        withCredentials: false,
        headers: {
            'Accept': 'application/json'
        },
        data: credentials
    }).then(response => {
        console.log("status" + response.status + "data:" + JSON.stringify(response.data));
        return response.data;
    }).catch(err => console.log(err.message));
}
